import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { ClientDetailScreen } from '../features/clients/ClientDetailScreen'

/** /clients/$id — детальная страница клиента (TT-warehouse №2 / DO-12).
 *  Объединяет header клиента + раздел «Торговые точки» с привязкой к складу
 *  и инвайт CLIENT_OWNER. Permission-gating внутри экрана. */
export const Route = createFileRoute('/clients/$id')({
  component: ClientDetailRoute,
})

function ClientDetailRoute() {
  const { id } = Route.useParams()
  return (
    <RequireAuth>
      <ClientDetailScreen clientId={Number(id)} />
    </RequireAuth>
  )
}
